"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const common_1 = require("@angular/common");
const material_1 = require("@angular/material");
const router_1 = require("@angular/router");
const forms_1 = require("@angular/forms");
const app_service_1 = require("../commons/app.service");
const global_1 = require("../commons/global");
const core_1 = require("@ngx-translate/core");
const BaseComponent_1 = require("../commons/BaseComponent");
const application_events_service_1 = require("../xs/services/events/application-events.service");
const loading_spinner_1 = require("../commons/ui/loading-spinner");
class AuthComponent extends BaseComponent_1.BaseComponent {
    constructor(service, router, ar, location, snackBar, dialog, translate, applicationEvents) {
        super(router, snackBar, dialog);
        this.service = service;
        this.router = router;
        this.ar = ar;
        this.location = location;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.translate = translate;
        this.emailControl = new forms_1.FormControl('', [forms_1.Validators.required, forms_1.Validators.email]);
        this.passControl = new forms_1.FormControl('', [forms_1.Validators.required, forms_1.Validators.pattern('[A-Za-z0-9_]{6,}')]);
        this.changeServer = 0;
        this.openEdgeWarningDialog();
        this.service.V.config.clientId = '4dmapper';
        delete localStorage['last4d_token'];
        delete localStorage['last4d_secret'];
        ar.params.subscribe(p => {
            if (p.message)
                this.openSnackBarError(errorMessages[p.message] || p.message);
        });
        service.V.api('/access/login/4dmapper').subscribe(s => {
            this.showFacebook = s.remoteClients.find(c => c.client_id == 'facebook');
            this.showGoogle = s.remoteClients.find(c => c.client_id == 'google');
        });
        ar.queryParams.subscribe(p => {
            this.prevpageStr = p.prevpage;
            if (p.prevpage) {
                this.prevpage = p.prevpage.split(',');
                this.prevpage[0] = '/' + this.prevpage[0];
            }
            else {
                this.prevpage = null;
            }
            this.toBooking = p.booking;
        });
    }
    ngOnInit() {
        loading_spinner_1.LoadingSpinner.end();
    }
    oauth(str) {
        let host = window.location.origin + this.location.prepareExternalUrl("");
        console.log("ENTER redirect URL: " + host + "auth/oauth/" + str);
        this.service.V.loginViaOAuthUrl(str, host + "auth/oauth/" + str, this.prevpageStr)
            .subscribe(s => {
            document.location.href = s;
        }, e => {
            console.log("ENTER error loginViaOauth");
            console.log(e);
        });
        /*
        if (str == "google") {
            this.service.V.api('/access/remoteAuth/' + this.service.V.cfg.clientId + "/260359117038-6p2nsf2276gpm3podd477vbn80evbg7d.apps.googleusercontent.com.json")
                .map(r => r.url)
                .subscribe(
                    s => {
                        document.location.href = s
                    },
                    e => {
                        console.log(e)
                    }
                )
        }
        */
    }
    /*
        navigateToRoute(route:string) {
            this.router.navigate([route],{
                queryParams:{prevpage:this.prevpageStr},
                replaceUrl:true
            })
        }
    */
    login() {
        this.loading = true;
        this.service.V.config.clientId = '4dmapper';
        delete localStorage['last4d_token'];
        delete localStorage['last4d_secret'];
        // Login users and then refresh api/me as well as bookings details.
        this.service.V.loginWithUsernameObservable(this.username, this.password).pipe(operators_1.mergeMap(res => this.service.refreshMe()), operators_1.mergeMap(res => this.service.refreshData()))
            .subscribe((r) => {
            this.postLogin();
        }, (e) => {
            this.loading = false;
            loading_spinner_1.LoadingSpinner.end();
            if (e.status == 403) {
                this.openSnackBarError("SIGNIN.WRONG_PASSWORD");
            }
            else {
                this.openSnackBarError(e.status + ": " + e.message, "GENERIC.OK");
            }
        });
    }
    postLogin() {
        this.loading = false;
        loading_spinner_1.LoadingSpinner.end();
        if (this.prevpage) {
            this.router.navigate(this.prevpage || ['/']);
        }
        else {
            //console.log("navigating to app")
            this.router.navigateByUrl(global_1.AppRoutes.MAIN);
        }
    }
    openForgotDialog() {
        // Load translations needed
        this.translate.get(['SIGNIN.FORGOT', 'SIGNIN.FORGOT_DESC', 'SIGNIN.EMAIL_PLACEHOLDER', 'SIGNIN.EMAIL_ERROR', 'SIGNIN.FORGOT_SUCCESS', 'SIGNIN.FORGOT_ERROR_NO_EMAIL', 'SIGNIN.FORGOT_ERROR', 'SIGNIN.FORGOT_ERROR_SOCIAL_MEDIA']).pipe(operators_1.mergeMap(trans => {
            // Keep reference to this success message needed further down. We do this so we don't call the translation services again.
            this.successMessage = trans['SIGNIN.FORGOT_SUCCESS'];
            this.errorMessage = trans['SIGNIN.FORGOT_ERROR'];
            this.errorNoEmail = trans['SIGNIN.FORGOT_ERROR_NO_EMAIL'];
            this.errorSocialMedia = trans['SIGNIN.FORGOT_ERROR_SOCIAL_MEDIA'];
            let res = {
                input: {
                    placeholder: trans['SIGNIN.EMAIL_PLACEHOLDER'],
                    value: this.username,
                    error: trans['SIGNIN.EMAIL_ERROR'],
                    copy: false
                },
                title: trans['SIGNIN.FORGOT'],
                message: trans['SIGNIN.FORGOT_DESC']
            };
            return rxjs_1.of(res);
        }), operators_1.mergeMap(res => {
            console.log(res);
            return this.openDialog(res.title, res.message, null, null, res.input, null);
        }), operators_1.mergeMap(res => {
            console.log(res);
            if (res) {
                this.loading = true;
                return this.service.V.forgetPasswordObservable(res.toString());
            }
            else {
                return rxjs_1.empty();
            }
        }))
            .subscribe((succ) => {
            this.loading = false;
            loading_spinner_1.LoadingSpinner.end();
            this.openSnackBarSuccess(this.successMessage);
        }, (err) => {
            console.log(err);
            this.loading = false;
            loading_spinner_1.LoadingSpinner.end();
            if (err.status == 412)
                this.openSnackBarWarn(err.status + ": " + this.errorNoEmail);
            else if (err.status == 41001)
                this.openSnackBarWarn(err.status + ": " + this.errorSocialMedia);
            else
                this.openSnackBarError(err.status + ": " + this.errorMessage);
        });
    }
    openRegisterDialog() {
        // Load translations needed
        this.translate.get(['SIGNIN.REGISTER_TITLE', 'SIGNIN.REGISTER_DESC', 'SIGNIN.EMAIL_PLACEHOLDER', 'SIGNIN.EMAIL_ERROR', 'SIGNIN.REGISTER_SUCCESS', 'SIGNIN.REGISTER_EMAIL_ERR', 'SIGNIN.REGISTER_ERROR', 'GENERIC.OK']).pipe(operators_1.mergeMap(trans => {
            //console.log(trans)
            // Keep reference to this success message needed further down. We do this so we don't call the translation services again.
            this.successMessage = trans['SIGNIN.REGISTER_SUCCESS'];
            this.errorMessage = trans['SIGNIN.REGISTER_ERROR'];
            this.errorNoEmail = trans['SIGNIN.REGISTER_EMAIL_ERR'];
            this.successAction = trans['GENERIC.OK'];
            let res = {
                input: {
                    placeholder: trans['SIGNIN.EMAIL_PLACEHOLDER'],
                    value: "",
                    error: trans['SIGNIN.EMAIL_ERROR'],
                    copy: false
                },
                title: trans['SIGNIN.REGISTER_TITLE'],
                message: trans['SIGNIN.REGISTER_DESC']
            };
            return rxjs_1.of(res);
        }), operators_1.mergeMap(res => {
            console.log(res);
            return this.openDialog(res.title, res.message, null, null, res.input, null);
        }), operators_1.mergeMap(res => {
            if (res) {
                this.loading = true;
                return this.service.requestEmailRegistration(res.toString());
            }
            else {
                return rxjs_1.empty();
            }
        }))
            .subscribe((succ) => {
            this.loading = false;
            loading_spinner_1.LoadingSpinner.end();
            this.openDialog('SIGNIN.REGISTER_SUCCESS', '', 'GENERIC.OK').subscribe();
        }, (err) => {
            console.log(err);
            this.loading = false;
            loading_spinner_1.LoadingSpinner.end();
            if (err.status == 10011)
                this.openSnackBarWarn(err.status + ": " + this.errorNoEmail);
            else
                this.openSnackBarError(err.status + ": " + this.errorMessage);
        });
    }
}
exports.AuthComponent = AuthComponent;
class LoginEmailComponent extends AuthComponent {
}
exports.LoginEmailComponent = LoginEmailComponent;
let errorMessages = {
    timeout: 'You need to login to access this section'
};
class SignupComponent extends BaseComponent_1.BaseComponent {
    constructor(t, service, router, ar, snackBar, dialog, applicationEvents) {
        super(router, snackBar, dialog);
        this.t = t;
        this.service = service;
        this.router = router;
        this.ar = ar;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.loading = false;
        this.terms = false;
        ar.queryParams.subscribe(p => {
            this.prevpageStr = p.prevpage;
            if (p.prevpage) {
                this.prevpage = p.prevpage.split(',');
                this.prevpage[0] = '/' + this.prevpage[0];
            }
            else {
                this.prevpage = null;
            }
        });
    }
    signup() {
        if (this.password != this.confirmPassword) {
            this.t.get('SIGNIN.PASSWORD_MATCH').subscribe(s => this.error = { message: s });
            return;
        }
        this.loading = true;
        this.service.V.signupWithObservable(this.username, this.password, { name: this.name, email: this.username }).pipe(operators_1.mergeMap(res => this.service.refreshMe()), operators_1.mergeMap(res => this.service.refreshData()))
            .subscribe((r) => {
            this.postLogin();
        }, (e) => {
            if (e.status == 400 && e.payload && e.payload.error == 'access_denied') {
                this.success = true;
            }
            else {
                this.error = e;
            }
            this.loading = false;
            loading_spinner_1.LoadingSpinner.end();
        });
    }
    postLogin() {
        this.loading = false;
        loading_spinner_1.LoadingSpinner.end();
        if (this.prevpage) {
            this.router.navigate(this.prevpage || ['/']);
        }
        else {
            //console.log("navigating to app")
            this.router.navigateByUrl('/play');
        }
    }
}
exports.SignupComponent = SignupComponent;
